/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Notif_EmptyInputs */

const en_lesson_notif_empty = /** @type {(inputs: Lesson_Notif_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notifications scheduled.`)
};

const he_lesson_notif_empty = /** @type {(inputs: Lesson_Notif_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין התראות מתוזמנות.`)
};

/**
* | output |
* | --- |
* | "No notifications scheduled." |
*
* @param {Lesson_Notif_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_notif_empty = /** @type {((inputs?: Lesson_Notif_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Notif_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_notif_empty(inputs)
	return he_lesson_notif_empty(inputs)
});